import React, {useEffect, useState, useLayoutEffect} from 'react';
import axios from 'axios';
import {
    Input,
    Button,
    Typography,
    Tooltip,
    Navbar,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Spinner,
    Select,
    Option,
} from "@material-tailwind/react";
import InputMask from "react-input-mask";
import {NumericFormat} from "react-number-format";
import MapComponent from "../shared/map_component";
import {ArrowPathIcon, ArrowUturnLeftIcon} from "@heroicons/react/16/solid";
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/24/solid";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import {es} from "intl-tel-input/i18n";
import {isValid, parse} from "date-fns";

export function OnlinePayment({commissionFee = 7, reference = null}) {
    const [error, setError] = useState('');
    const [step, setStep] = useState(1);
    const [parcelCode, setParcelCode] = useState('');
    const [lot, setLot] = useState(null);
    const [debts, setDebts] = useState(null);
    const [selBimDebts, setSelBimDebts] = useState([]);
    const [selYearlyDebts, setSelYearlyDebts] = useState([]);
    const [aft, setAft] = useState(null);
    const [csrf, setCsrf] = useState(null);
    const [user, setUser] = useState({
        name: '', parental_last_name: '', maternal_last_name: '', birthday: '', email: '', phone: ''
    });
    const [card, setCard] = useState({
        name: '', pan: '', exp_month: '01', exp_year: '25', cvv: ''
    });
    const [userErrors, setUserErrors] = useState({
        name: 'Requerido',
        parental_last_name: 'Requerido',
        birthday: 'Requerido',
        maternal_last_name: 'Requerido',
        email: 'Requerido'
    });
    const [cardErrors, setCardErrors] = useState({
        name: 'Requerido', pan: 'Requerido', cvv: 'Requerido'
    });
    const [processing, setProcessing] = useState(false);
    const [errorDialogMsg, setErrorDialogMsg] = useState(null);
    const [invoiceID, setInvoiceId] = useState(null);
    const [phone, setPhone] = useState('');
    const [validPhone, setValidPhone] = useState(false);

    const [openResetDialog, setOpenResetDialog] = useState(false);
    const [openWarningDialog, setOpenWarningDialog] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);

    const handleReset = () => {
        if (reference) {
            window.history.replaceState(null, "", window.location.pathname);
        }
        setStep(1);
        setError('');
        setParcelCode('');
        setLot(null);
        setDebts(null);
        setSelBimDebts([]);
        setSelYearlyDebts([]);
        setProcessing(false);
        setOpenResetDialog(false);
        setOpenWarningDialog(false);
        setOpenEndDialog(false);
        setOpenErrorDialog(false);
        setErrorDialogMsg(null);
        setInvoiceId(null);
        setCardErrors({
            name: 'Requerido', pan: 'Requerido', cvv: 'Requerido'
        });
        setCard({
            name: '', pan: '', exp_month: '01', exp_year: '25', cvv: ''
        });
    };

    useLayoutEffect(async () => {
        if (reference) {
            await handleSelectedLot(reference);
            setParcelCode(reference);
        }
        setPageLoading(false);
    }, []);

    useEffect(() => {
        if (PagandoCheck) {
            setAft(PagandoCheck.getAFT());
        }

        const token = document.querySelector('meta[name="csrf-token"]');
        setCsrf(token.content);
    }, []);

    useEffect(() => {
        const yearlyData = Object.values(calculateYearlyTotals(selBimDebts));

        setSelYearlyDebts(yearlyData);
    }, [selBimDebts]);

    useEffect(() => {
        setUser({
            ...user,
            phone: phone.replace(/\s+/g, '')
        });

    }, [phone]);

    const handleSearch = async () => {
        setError(null);
        setLot(null);

        if (parcelCode.trim() === "") return setError("Ingrese una clave válida");

        await handleSelectedLot(parcelCode);
    }

    const handleSelectedLot = async (parcel_code) => {
        try {
            const [lotsResponse, debtsResponse] = await Promise.all([
                fetch(`/lots/${parcel_code}/search_by_code.json`),
                fetch(`/lots/${parcel_code}/debts.json`)
            ]);

            if (!lotsResponse.ok) {
                setError("No se encontraron datos para este código.");
                setStep(1);
                return;
            } else {

            }
            const lotsData = await lotsResponse.json();
            setLot(lotsData);

            if (debtsResponse.ok) {
                const debtsData = await debtsResponse.json();

                setDebts(debtsData);
                setSelBimDebts(debtsData);
            } else {
                setError("El predio ingresado no cuenta con adeudos.");
                return;
            }

        } catch (err) {
            console.error("Error al buscar el predio:", err);
        }

        setStep(2);
    }

    const calculateYearlyTotals = (debts) => {
        return debts.reduce((acc, debt) => {
            const year = debt.year;
            if (!acc[year]) {
                acc[year] = {
                    year: year,
                    tax: 0,
                    university_tax: 0,
                    surcharge: 0,
                    subtotal: 0,
                    discount: 0,
                    total: 0,
                };
            }
            acc[year].tax += debt.tax;
            acc[year].university_tax += debt.university_tax;
            acc[year].surcharge += debt.surcharge;
            acc[year].subtotal += debt.subtotal;
            acc[year].discount += debt.discount;
            acc[year].total += debt.total;
            return acc;
        }, {});
    };

    const totalSelected = selBimDebts.reduce(
        (acc, debt) => acc + debt.total,
        0
    ) + commissionFee;
    const totalSelectedRounded = Math.ceil(totalSelected);

    const handleModifySelection = () => {
        setStep(2);
    };

    const toggleDebt = (debt) => {
        setSelBimDebts((prev) => {
            const isSelected = prev.some((item) => item.id === debt.id);

            if (isSelected) {
                return prev.filter((item) => item.id_debt < debt.id_debt);
            } else {
                const affectedDebts = debts.filter(
                    (item) => item.id_debt <= debt.id_debt
                );
                return [...affectedDebts];
            }
        });
    };

    const handleUserInput = (e) => {
        const {name, value} = e.target;
        let error = ""

        if (name === 'birthday' && value.trim() !== "") {
            const result = parse(value, 'dd/MM/yyyy', new Date());
            if (!isValid(result)) {
                error = 'Ingrese una fecha valida.'
            }
        }

        setUser(prevUser => ({
            ...prevUser,
            [name]: value,
        }));

        setUserErrors(prevErrors => ({
            ...prevErrors,
            [name]: value.trim() === "" ? "Este campo es obligatorio" : error,
        }));
    }

    const handleCardInput = (e) => {
        const {name, value} = e.target;
        const trimmedValue = value.trim();

        const errors = {
            name: trimmedValue === "" ? "Este campo es obligatorio." : "",
            pan: trimmedValue.length < 19 ? "Introduzca los 16 dígitos de la tarjeta." : "",
            cvv: trimmedValue.length < 3 ? "Introduzca los 3 dígitos del CVV." : "",
        };

        setCard(prevCard => ({
            ...prevCard,
            [name]: value,
        }));

        setCardErrors(prevErrors => ({
            ...prevErrors,
            [name]: errors[name],
        }));
    }

    const handleEmailInput = (e) => {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const value = e.target.value;

        setUser({
            ...user,
            email: value
        });

        setUserErrors({
            ...userErrors,
            email: !emailPattern.test(value) ? 'El correo no es valido.' : ''
        });
    }

    const handleContinue = () => {
        if (selBimDebts.length === 0) {
            setOpenWarningDialog(true);
        } else {
            setStep(3);
        }
    };

    const handlePayment = async () => {
        const hasUserErrors = Object.values(userErrors).some(error => error !== "");
        const hasCardErrors = Object.values(cardErrors).some(error => error !== "");

        if (hasUserErrors || hasCardErrors || !validPhone) {
            setErrorDialogMsg("Todos los campos del formulario son obligatorios");
            setOpenErrorDialog(true);
            return;
        }

        setProcessing(true);
        const debtsIds = selBimDebts.map(item => item.id);

        try {
            const response = await axios.post(`/process_payment.json`, {
                charged: totalSelectedRounded,
                user: user,
                card: card,
                aft: aft,
                parcel_code: parcelCode,
                debts: debtsIds
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrf,
                }
            });

            if (response.status === 200) {
                if (response.data.code === 66) {
                    setInvoiceId(response.data.id);
                    const url = `/pago/${response.data.id}/recibo/`;
                    window.open(url, '_blank');

                    setOpenEndDialog(true);
                } else {
                    await handlePaymentCompletion(response.data['token'], response.data['userId'],
                        response.data['cardId'], response.data['orderId'], debtsIds)
                }
            }
        } catch (err) {
            setProcessing(false);
            setErrorDialogMsg(err.response.data.error);
            setOpenErrorDialog(true);
        }
    };

    const handlePaymentCompletion = async (accessToken, userId, cardId, orderId, debtsIds) => {
        const authParams = {
            // Tu token de acceso
            token: accessToken,
            // Identificador del cliente registrado en la API
            userId: userId,
            // Identificador de la tarjeta registrada en la API
            cardId: cardId,
            // Identificador de la orden a autenticar
            orderId: orderId
        };

        const authSuccessful = await PagandoCheck.run3DSecure(authParams);

        if (authSuccessful) {
            try {
                const response = await axios.post(`/complete_order.json`, {
                    charged: totalSelectedRounded,
                    order_id: orderId,
                    user_id: userId,
                    aft: aft,
                    parcel_code: parcelCode,
                    debts: debtsIds,
                    card: {
                        card_id: cardId,
                        cvv: card.cvv,
                    },
                    user: {
                        email: user.email,
                    },
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': csrf,
                    }
                });

                if (response.status === 200) {
                    if (response.data.code === 66) {
                        setInvoiceId(response.data.id);
                        const url = `/pago/${response.data.id}/recibo/`;
                        window.open(url, '_blank');

                        setOpenEndDialog(true);
                    } else {
                        console.error(response.data.code);
                    }
                }
            } catch (err) {
                setProcessing(false);
                setErrorDialogMsg(err.response.data.error);
                setOpenErrorDialog(true);
            }
        } else {
            setOpenErrorDialog(true);
        }
        setProcessing(false);
    }

    const months = Array.from({length: 12}, (_, i) => String(i + 1).padStart(2, "0"));
    const years = Array.from({length: 11}, (_, i) => ((new Date()).getFullYear() + i).toString().padStart(2, "0"));

    return (
        <section className="flex flex-col gap-4 w-full px-2 md:px-4 lg:px-10 py-4 md:py-8 sm:py-2">
            <Navbar className="mx-auto max-w-screen-xl px-2 py-2 lg:px-6 lg:py-4" shadow={false}>
                <div className="flex items-center justify-between text-blue-gray-900">
                    <img
                        src="https://ojinagagob.mx/wp-content/uploads/2024/09/Ojinaga.png"
                        className="w-80 mx-auto"
                    />
                </div>
            </Navbar>
            {pageLoading ? (
                <div className="w-full mt-24 animate-pulse">
                    <div className="text-center">
                        <Typography
                            as="div"
                            variant="h2"
                            className="w-1/2 mx-auto rounded-full bg-gray-300 mb-4"
                        >
                            &nbsp;
                        </Typography>
                        <Typography
                            as="div"
                            variant="paragraph"
                            className="w-1/2 mx-auto rounded-full bg-gray-300"
                        >
                            &nbsp;
                        </Typography>
                    </div>
                    <div className="mt-8 mb-2 mx-auto w-80 max-w-screen-lg lg:w-1/2">
                        <div className="mb-1 flex flex-col gap-6">
                            <Typography
                                as="div"
                                variant="small"
                                className="h-3 w-1/4 rounded-full bg-gray-300 -mb-3"
                            >
                                &nbsp;
                            </Typography>
                            <Button
                                disabled
                                tabIndex={-1}
                                fullWidth
                                className="py-6 h-8 bg-gray-300 shadow-none hover:shadow-none"
                            >
                                &nbsp;
                            </Button>
                        </div>

                        <Button
                            disabled
                            tabIndex={-1}
                            fullWidth
                            className="mt-6 py-5 h-8 bg-gray-300 shadow-none hover:shadow-none"
                        >
                            &nbsp;
                        </Button>
                    </div>
                </div>
            ) : step === 1 ? (
                    <div className="w-full mt-24">
                        <div className="text-center">
                            <Typography variant="h2" className="font-bold mb-4">Paga tu predial en línea</Typography>
                            <Typography variant="paragraph" color="blue-gray" className="text-lg font-normal">Busca tu
                                predio utilizando su clave catastral.</Typography>
                        </div>
                        <form className="mt-8 mb-2 mx-auto w-80 max-w-screen-lg lg:w-1/2">
                            <div className="mb-1 flex flex-col gap-6">
                                <Typography variant="small" color="blue-gray" className="-mb-3 font-medium">
                                    Clave catastral
                                </Typography>
                                <InputMask
                                    mask="512999-999-999"
                                    value={parcelCode}
                                    formatChars={{
                                        "2": "[1-2]",
                                        "9": "[0-9]"
                                    }}
                                    onChange={(e) => setParcelCode(e.target.value)}
                                >
                                    {(inputProps) => (
                                        <Input
                                            {...inputProps}
                                            type="tel"
                                            size="lg"
                                            placeholder="51XXXX-XXX-XXX"
                                            className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                                        />
                                    )}
                                </InputMask>
                            </div>

                            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                            <Button className="mt-6" fullWidth onClick={handleSearch}>
                                Continuar
                            </Button>
                        </form>
                    </div>
                ) :
                step === 2 ? (
                    <>
                        <div>
                            <h6 className="font-semibold uppercase text-gray-600">
                                PAGO DE PREDIAL
                            </h6>
                            <div className="bg-white p-5 border rounded-md">
                                <div className="flex md:flex-row md:justify-between flex-col items-center">
                                    <div className='w-full flex flex-row md:flex-col text-left'>
                                        <h6 className="font-semibold">Clave Buscada:</h6>
                                        <p className='pl-2 lg:pl-0'>{parcelCode}</p>
                                    </div>
                                    <div
                                        className='flex flex-col gap-2 md:justify-end md:flex-row w-full md:w-2/3 lg:w-1/5 2xl:w-1/8 mt-2 md:mt-0'>
                                        <Button
                                            size="sm"
                                            className="bg-red-700 flex items-center md:py-2 py-4 w-full lg:w-3/4 justify-center mt-0"
                                            onClick={() => setOpenResetDialog(true)}
                                            style={{marginLeft: 'auto'}}
                                        >
                                            <ArrowPathIcon className='w-5 h-5 mr-2'/>
                                            Nueva consulta
                                        </Button>
                                    </div>
                                </div>

                                <Dialog open={openResetDialog} handler={setOpenResetDialog}>
                                    <DialogHeader>Confirmación</DialogHeader>
                                    <DialogBody>¿Estás seguro de restablecer?</DialogBody>
                                    <DialogFooter>
                                        <Button
                                            variant="text"
                                            onClick={() => setOpenResetDialog(false)}
                                            className="mr-2"
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            className="bg-red-500 text-white"
                                            onClick={handleReset}
                                        >
                                            Confirmar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>
                            </div>
                        </div>
                        <div className='w-full'>
                            <h6 className="font-semibold uppercase text-gray-600">
                                Información del predio
                            </h6>
                            <div className="flex flex-col lg:flex-row gap-4">
                                <div className="flex-grow border p-4 rounded-md w-full lg:w-1/2 overflow-x-hidden">
                                    {lot && (
                                        <table className="w-full min-w-max table-auto text-left">
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold"
                                                    >
                                                        Tipo de Predio:
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        className="font-normal text-gray-600"
                                                    >
                                                        {lot.lot_location_type}
                                                    </Typography>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold"
                                                    >
                                                        Propietario:
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        className="font-normal text-gray-600"
                                                    >
                                                        {lot.name} {lot.parental_last_name} {lot.maternal_last_name}
                                                    </Typography>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold"
                                                    >
                                                        Dirección:
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        className="font-normal text-gray-600"
                                                    >
                                                        {lot.road_name}{lot.ext_num ? " #" + lot.ext_num : ""}, {lot.neighborhood_name}
                                                        {lot.postal_code ? ', C.P. ' + lot.postal_code : ''}
                                                    </Typography>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold"
                                                    >
                                                        Referencias:
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        className="font-normal text-gray-600"
                                                    >
                                                        {lot.address_references === null ? '' : lot.address_references}
                                                    </Typography>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold"
                                                    >
                                                        Sup. Terreno:
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        className="font-normal text-gray-600"
                                                    >
                                                        {lot.land_area.toFixed(2)}
                                                    </Typography>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold"
                                                    >
                                                        Sup. Const:
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography
                                                        variant="small"
                                                        className="font-normal text-gray-600"
                                                    >
                                                        {lot.construction_area.toFixed(2)}
                                                    </Typography>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                {lot.latitude && (
                                    <div className="flex-grow border rounded-md w-full lg:w-1/2 min-h-[350px]">
                                        <MapComponent
                                            parcel_code={parcelCode}
                                            latitude={lot.latitude}
                                            longitude={lot.longitude}
                                            toggleMapType={false}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="flex justify-between items-center mt-8">
                                <h6 className="font-semibold uppercase text-gray-600">
                                    Adeudos
                                </h6>
                            </div>

                            <div className='w-full overflow-x-scroll'>
                                <table className="w-full min-w-[640px] table-auto">
                                    <thead>
                                    <tr>
                                        {["", "Año", "Bimestre", "Impuesto", "Imp. Univ.", "Recargos", "Subtotal", "Descuento", "Total"].map(
                                            (el) => (
                                                <th
                                                    key={el}
                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                >
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        {el}
                                                    </Typography>
                                                </th>
                                            )
                                        )}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(!debts || debts.length === 0) ? (
                                        <Typography
                                            variant="normal"
                                            color="blue-gray"
                                            className="font-bold text-center"
                                        >
                                            El predio no tiene adeudos.
                                        </Typography>
                                    ) : (debts.map((debt, index) => {
                                            const className = `py-3 px-5 ${
                                                index === debts.length - 1 ? "" : "border-b border-blue-gray-50"
                                            }`;
                                            const disabled = index === 0;
                                            return (
                                                <tr key={debt.id} className="hover:bg-gray-50 cursor-pointer">
                                                    <td className={className}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selBimDebts.some(
                                                                (item) => item.id === debt.id
                                                            )}
                                                            onChange={() => toggleDebt(debt)}
                                                            disabled={disabled}
                                                        />
                                                    </td>
                                                    <td className={className}>{debt.year}</td>
                                                    <td className={className}>{debt.bimester}</td>
                                                    <td className={className}>${debt.tax.toFixed(2)}</td>
                                                    <td className={className}>${debt.university_tax.toFixed(2)}</td>
                                                    <td className={className}>${debt.surcharge.toFixed(2)}</td>
                                                    <td className={className}>${debt.subtotal.toFixed(2)}</td>
                                                    <td className={className}>
                                                        <Tooltip content={`${debt.discount_percentage}%`}
                                                                 placement="right">
                                                            <span>${debt.discount.toFixed(2)}</span>
                                                        </Tooltip>
                                                    </td>
                                                    <td className={className}>${(debt.total).toFixed(2)}</td>
                                                </tr>
                                            );
                                        })
                                    )}
                                    </tbody>
                                </table>
                            </div>

                            {(debts && debts.length > 0) && (
                                <div className="mt-8 w-full flex justify-end">
                                    <div className="md:w-4/12 w-full">
                                        <div className="w-full p-6 mb-2 rounded-lg shadow-lg"
                                             style={{backgroundColor: '#33277a'}}>
                                            <div className="flex justify-between text-white text-xl font-semibold">
                                                <span className="font-bold text-sm">Redondeo:</span>
                                                <span>${(Math.ceil((totalSelected - commissionFee)) - (totalSelected - commissionFee)).toFixed(2)}</span>
                                            </div>
                                            <div className="flex justify-between text-white text-xl font-semibold">
                                                <span className="font-bold text-sm">Total de adeudos:</span>
                                                <span><NumericFormat
                                                    value={(Math.ceil((totalSelected - commissionFee))).toFixed(2)}
                                                    displayType={'text'}
                                                    prefix={'$'}
                                                    allowLeadingZeros
                                                    thousandSeparator=","
                                                /></span>
                                            </div>
                                        </div>
                                        <Button
                                            className="bg-gray-500 text-white rounded-md px-8 py-3 text-lg w-full hover:scale-110 transition-colors duration-300"
                                            onClick={handleContinue}
                                        >
                                            CONTINUAR
                                        </Button>
                                    </div>
                                </div>
                            )}
                            <Dialog open={openWarningDialog} handler={setOpenWarningDialog}>
                                <DialogHeader>Advertencia</DialogHeader>
                                <DialogBody>
                                    <Typography>
                                        Por favor, selecciona al menos un adeudo para continuar con el pago.
                                    </Typography>
                                </DialogBody>
                                <DialogFooter>
                                    <Button
                                        className="bg-blue-500 text-white"
                                        onClick={() => setOpenWarningDialog(false)}
                                    >
                                        Aceptar
                                    </Button>
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </>
                ) : step === 3 ? (
                    <>
                        <div>
                            <h6 className="font-semibold uppercase text-gray-600">
                                PAGO DE PREDIAL
                            </h6>
                            <div className="bg-white p-5 border rounded-md">
                                <div className="flex md:flex-row md:justify-between flex-col items-center">
                                    <div className='w-full flex flex-row md:flex-col text-left'>
                                        <h6 className="font-semibold">Clave Buscada:</h6>
                                        <p className='pl-2 lg:pl-0'>{parcelCode}</p>
                                    </div>
                                    <div
                                        className='flex flex-col-reverse gap-2 md:justify-end md:flex-row w-full md:w-2/3 lg:w-2/5 2xl:w-1/4 mt-2 md:mt-0'>
                                        <Button
                                            size="sm"
                                            className="bg-amber-500 flex items-center md:py-2 py-4 w-full justify-center"
                                            onClick={handleModifySelection}
                                            style={{marginLeft: 'auto'}}
                                        >
                                            <ArrowUturnLeftIcon className='w-5 h-5 mr-2'/>
                                            Regresar
                                        </Button>
                                        <Button
                                            size="sm"
                                            className="bg-red-700 flex items-center md:py-2 py-4 w-full justify-center"
                                            onClick={() => setOpenResetDialog(true)}
                                            style={{marginLeft: 'auto'}}
                                        >
                                            <ArrowPathIcon className='w-5 h-5 mr-2'/>
                                            Nueva consulta
                                        </Button>
                                    </div>
                                </div>

                                <Dialog open={openResetDialog} handler={setOpenResetDialog}>
                                    <DialogHeader>Confirmación</DialogHeader>
                                    <DialogBody>¿Estás seguro de restablecer?</DialogBody>
                                    <DialogFooter>
                                        <Button
                                            variant="text"
                                            onClick={() => setOpenResetDialog(false)}
                                            className="mr-2"
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            className="bg-red-500 text-white"
                                            onClick={handleReset}
                                        >
                                            Confirmar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>
                            </div>
                        </div>

                        <div>
                            <h6 className="flex font-semibold uppercase text-gray-600">
                                Confirmar pago
                            </h6>
                            <div className='w-full flex flex-col md:flex-row gap-4'>
                                <div className='w-full md:min-w-[50%] p-4 border rounded-md'>
                                    <div className="flex flex-col gap-4 px-4">
                                        <h6 className="text-blue-gray-300 text-sm mt-3 mb-1 font-bold uppercase">
                                            Información del método de pago
                                        </h6>
                                        <div className='flex flex-col md:flex-row gap-4'>
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Nombre <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className={`${userErrors.name !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                    value={user.name}
                                                    onChange={handleUserInput}
                                                    required={true}
                                                />
                                            </div>
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Apellido Paterno <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="parental_last_name"
                                                    className={`${userErrors.parental_last_name !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                    value={user.parental_last_name}
                                                    onChange={handleUserInput}
                                                    required={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-col md:flex-row gap-4">
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Apellido Materno <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="maternal_last_name"
                                                    className={`${userErrors.maternal_last_name !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                    value={user.maternal_last_name}
                                                    onChange={handleUserInput}
                                                    required={true}
                                                />
                                            </div>
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Fecha de nacimiento <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <InputMask
                                                    mask="99/99/9999"
                                                    maskChar=''
                                                    value={user.birthday}
                                                    onChange={handleUserInput}
                                                >
                                                    {(inputProps) => (
                                                        <input
                                                            {...inputProps}
                                                            type="tel"
                                                            name="birthday"
                                                            placeholder="dd/mm/yyyy"
                                                            className={`${userErrors.birthday !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                        />
                                                    )}
                                                </InputMask>
                                            </div>
                                        </div>
                                        <div className="flex flex-col md:flex-row gap-4">
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Email <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className={`${userErrors.email !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                    value={user.email}
                                                    onChange={handleEmailInput}
                                                    required={true}
                                                />
                                            </div>
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Teléfono <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <div
                                                    className={`${!validPhone && '!outline-red-500 !ring-red-500 has-[input:focus]:!ring-red-500 '} has-[input]:text-blue-gray-600 *:w-full has-[input]:rounded has-[input]:!text-sm has-[input]:shadow has-[input:focus]:outline-none has-[input:focus]:ring-blue-500 has-[input:focus]:ring has-[input]:w-full has-[input]:ease-linear has-[input]:transition-all has-[input]:duration-150`}>
                                                    <IntlTelInput
                                                        className={'form-control form-control-lg text-secondary'}
                                                        onChangeNumber={setPhone}
                                                        onChangeValidity={setValidPhone}
                                                        initialValue={phone}
                                                        initOptions={{
                                                            initialCountry: "mx",
                                                            i18n: es,
                                                            onlyCountries: ['mx', 'us'],
                                                            countryOrder: ['mx', 'us'],
                                                            strictMode: true,
                                                            separateDialCode: true,
                                                            nationalMode: true,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="my-2 border-b-1"/>
                                        <h6 className="text-blue-gray-300 text-sm mt-3 mb-1 font-bold uppercase">
                                            Forma de pago
                                        </h6>
                                        <div className='flex flex-row gap-4'>
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                >
                                                    Nombre en tarjeta <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className={`${cardErrors.name !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                    value={card.name}
                                                    onChange={handleCardInput}
                                                    required={true}
                                                />
                                            </div>
                                        </div>
                                        <div className='flex flex-row gap-4'>
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Número en tarjeta <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <InputMask
                                                    mask="9999-9999-9999-9999"
                                                    maskChar=''
                                                    value={card.pan}
                                                    onChange={handleCardInput}
                                                >
                                                    {(inputProps) => (
                                                        <input
                                                            {...inputProps}
                                                            type="tel"
                                                            name="pan"
                                                            placeholder="0000-0000-0000-0000"
                                                            className={`${cardErrors.pan !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                        />
                                                    )}
                                                </InputMask>
                                            </div>
                                        </div>
                                        <div className='flex flex-row gap-6'>
                                            <div className="relative w-full mb-3">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                    htmlFor="grid-password"
                                                >
                                                    Fecha de vencimiento <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <div className='flex flex-row justify-start gap-4'>
                                                    <div className='w-full max-w-[25%]'>
                                                        <Select
                                                            className='!min-w-0 border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-blue-500 focus:ring w-full ease-linear transition-all duration-150'
                                                            menuProps={{
                                                                className: "text-gray-700 rounded-md shadow-md p-2",
                                                            }}
                                                            containerProps={{
                                                                className: '!min-w-0'
                                                            }}
                                                            labelProps={{
                                                                className: "!border-0 before:!border-0 after:!border-0",
                                                            }}
                                                            value={card.exp_month}
                                                            size='lg'
                                                            onChange={(val) => setCard({
                                                                ...card,
                                                                exp_month: val
                                                            })}
                                                        >
                                                            {months.map((month) => (
                                                                <Option key={month} value={month}>
                                                                    {month}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </div>

                                                    <div className='w-full max-w-[25%]'>
                                                        <Select
                                                            className='!min-w-0 border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-blue-500 focus:ring w-full ease-linear transition-all duration-150'
                                                            menuProps={{
                                                                className: "text-gray-700 rounded-md shadow-md p-2",
                                                            }}
                                                            containerProps={{
                                                                className: '!min-w-0'
                                                            }}
                                                            labelProps={{
                                                                className: "!border-0 before:!border-0 after:!border-0",
                                                            }}
                                                            value={card.exp_year}
                                                            size='lg'
                                                            onChange={(val) => setCard({
                                                                ...card,
                                                                exp_year: val
                                                            })}
                                                        >
                                                            {years.map((year) => (
                                                                <Option key={year} value={year.slice(-2)}>
                                                                    {year}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative w-full mb-3 max-w-[25%]">
                                                <label
                                                    className="flex gap-1 block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                >
                                                    CVV <sup
                                                    className={'block antialiased font-sans text-sm font-light leading-normal text-red-500'}>*</sup>
                                                </label>
                                                <InputMask
                                                    mask="999"
                                                    maskChar=''
                                                    value={card.cvv}
                                                    onChange={handleCardInput}
                                                >
                                                    {(inputProps) => (
                                                        <input
                                                            {...inputProps}
                                                            type="tel"
                                                            name="cvv"
                                                            placeholder="000"
                                                            className={`${cardErrors.cvv !== '' && '!outline-red-500 !ring-red-500'} border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`}
                                                            required={true}
                                                        />
                                                    )}
                                                </InputMask>
                                            </div>
                                        </div>
                                        <Typography variant={"small"} color={"red"}>* Todos los campos son
                                            obligatorios.</Typography>
                                    </div>
                                </div>
                                <div className='w-full md:min-w-[50%] p-4 border rounded-md'>
                                    <div className='w-full overflow-x-scroll'>
                                        <table className="w-full min-w-[640px] table-auto">
                                            <thead>
                                            <tr>
                                                {[
                                                    "Año",
                                                    "Impuesto",
                                                    "Imp. Univ.",
                                                    "Recargos",
                                                    "Subtotal",
                                                    "Descuento",
                                                    "Total"
                                                ].filter(Boolean).map((el) => (
                                                    <th key={el}
                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left">
                                                        <Typography variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400">
                                                            {el}
                                                        </Typography>
                                                    </th>
                                                ))}
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {selYearlyDebts.map((debt, index) => {
                                                const className = `py-3 px-5 ${index % 2 ? 'bg-gray-50' : ''}`;
                                                return (
                                                    <tr key={debt.year}>
                                                        <td className={className}>{debt.year}</td>
                                                        <td className={className}>${debt.tax.toFixed(2)}</td>
                                                        <td className={className}>${debt.university_tax.toFixed(2)}</td>
                                                        <td className={className}>${debt.surcharge.toFixed(2)}</td>
                                                        <td className={className}>${debt.subtotal.toFixed(2)}</td>
                                                        <td className={className}>${debt.discount.toFixed(2)}</td>
                                                        <td className={className}>${debt.total.toFixed(2)}</td>
                                                    </tr>
                                                );
                                            })}
                                            <tr className='border-t border-blue-gray-50'>
                                                <td colSpan="6">
                                                    <Typography variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400 text-right">
                                                        COMISIÓN PAGO EN LÍNEA
                                                    </Typography>
                                                </td>
                                                <td className='py-3 px-5'>
                                                    <NumericFormat
                                                        value={commissionFee.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="flex md:flex-row md:gap-8 justify-end mt-8">
                                        <div className="lg:w-6/12 w-full flex justify-end">
                                            <div className="w-full">
                                                <div className="w-full p-6 mb-2 rounded-lg shadow-lg"
                                                     style={{backgroundColor: '#33277a'}}>
                                                    <div
                                                        className="flex justify-between text-white text-xl font-semibold">
                                                        <span className="font-bold text-sm">Redondeo:</span>
                                                        <span>${(Math.ceil(totalSelected) - totalSelected.toFixed(2)).toFixed(2)}</span>
                                                    </div>
                                                    <div
                                                        className="flex justify-between text-white text-xl font-semibold">
                                                        <span className="font-bold text-sm">Total a pagar:</span>
                                                        <span><NumericFormat
                                                            value={totalSelectedRounded.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            allowLeadingZeros
                                                            thousandSeparator=","
                                                        /></span>
                                                    </div>
                                                </div>
                                                <Button
                                                    disabled={processing}
                                                    className="flex flex-row gap-2 justify-center bg-green-500 text-white w-full rounded-md px-8 py-3 text-lg hover:scale-110 "
                                                    onClick={() => handlePayment()}
                                                >
                                                    {processing ? (
                                                            <Spinner color='indigo'/>
                                                        )
                                                        : (
                                                            "Pagar"
                                                        )
                                                    }
                                                </Button>
                                                <Typography variant={"small"} className='text-blue-gray-300'>Se realiza
                                                    un
                                                    cargo de <NumericFormat
                                                        value={commissionFee.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    /> por comisión de pago en línea.</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <Dialog open={openErrorDialog} handler={setOpenErrorDialog}>
                                    <DialogBody>
                                        <div className='flex flex-col justify-center text-center'>
                                            <XCircleIcon color='red' className='w-1/4 mx-auto'/>
                                            <Typography variant='h3' className='mb-3'>
                                                Ocurrió un error
                                            </Typography>
                                            {errorDialogMsg ? (
                                                <Typography>
                                                    {errorDialogMsg}
                                                </Typography>
                                            ) : (
                                                <>
                                                    <Typography color='blue-gray'>
                                                        La validación de identidad no fue procesada con éxito.
                                                    </Typography>
                                                    <Typography color='blue-gray'>
                                                        Verifique su forma de pago o intente nuevamente.
                                                    </Typography>
                                                </>
                                            )}
                                        </div>
                                    </DialogBody>
                                    <DialogFooter>
                                        <Button
                                            className="bg-green-500 text-white"
                                            onClick={() => {
                                                setOpenErrorDialog(false);
                                                setProcessing(false);
                                            }}
                                        >
                                            Cerrar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>

                                <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                                    <DialogBody>
                                        <div className='flex flex-col justify-center text-center'>
                                            <CheckCircleIcon color='green' className='w-1/4 mx-auto'/>
                                            <Typography variant='h3' className='mb-3'>
                                                ¡Gracias por tu pago!
                                            </Typography>
                                            <Typography color='blue-gray'>
                                                Tu pago de predial se ha completado correctamente.
                                            </Typography>
                                            <Typography color='blue-gray'>
                                                En breve, tu recibo se abrirá en otra ventana.
                                            </Typography>

                                            <Typography variant='small' className='mt-6'>
                                                Si tu recibo no se abre en automático puedes verlo <strong
                                                className='hover:text-blue-gray-500 underline cursor-pointer'
                                                onClick={() => {
                                                    window.open(`/pago/${invoiceID}/recibo/`, '_blank');
                                                }}>aquí</strong>
                                            </Typography>
                                        </div>
                                    </DialogBody>
                                    <DialogFooter>
                                        <Button
                                            className="bg-green-500 text-white w-full"
                                            onClick={() => handleReset()}
                                        >
                                            Finalizar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>
                            </div>
                        </div>
                    </>
                ) : null}
        </section>
    );
}

export default OnlinePayment;
